import type { FmMapElement } from './elements/elements.types';
import type { FmPrimaryMapWorkspaceData } from '@/shared/config/mapSlotRegistry';
import { WORKSPACE_PRIMARY_MAP_SLOT_KEY } from '@/shared/config/mapSlotRegistry';

/** Builds the sealed interactive stand map a product showcase section places. */
export function createFmProductShowcaseMapMedia(
  publishedMapData: FmPrimaryMapWorkspaceData,
  selectedStandId: string | null,
  onStandSelect: (standId: string) => void,
): FmMapElement {
  return {
    element: 'map',
    layoutPreset: 'stacked',
    figure: {
      kind: 'live',
      slotKey: WORKSPACE_PRIMARY_MAP_SLOT_KEY,
      slotProps: {
        propertyId: publishedMapData.activePropertyId ?? undefined,
        ...(selectedStandId
          ? { selectedFeatureId: selectedStandId, selectedFeatureKind: 'stand' }
          : {}),
        layerIds: ['property-boundary', 'forest-stands'],
        baseMapId: 'satellite',
        interactionMode: 'explore',
        onStandSelect,
        mapData: publishedMapData,
      },
    },
    testId: 'landing-interactive-stand-map',
  };
}
